export default __webpack_public_path__ + "css/creditNote.bundle.css";